import ChatIcon from '@/common/components/icons/chat';
import { HAMI_PAGE_PATHNAMES } from '@/modules/hami/hamiRoutes';
import classNames from '@/common/utils/classNames';
import { useUserInfoStore } from '@/modules/login/store/userInfo';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { sendDoctorDesktopChatsClick } from './doctorDesktopChatsAnalytics';
import { DOCTOR_CHATS_PATH, shouldShowDoctorChatsHeaderLink } from './doctorChatsHeaderLink.shared';

export { DOCTOR_CHATS_PATH, shouldShowDoctorChatsHeaderLink } from './doctorChatsHeaderLink.shared';

export const DoctorChatsHeaderLink = () => {
  const user = useUserInfoStore(state => state.info);
  const router = useRouter();

  if (!shouldShowDoctorChatsHeaderLink(user)) return null;

  const active = HAMI_PAGE_PATHNAMES.includes(router.pathname) || router.asPath.startsWith('/_/chats');

  return (
    <Link
      href={DOCTOR_CHATS_PATH}
      prefetch={false}
      aria-label="گفت‌وگوها"
      title="گفت‌وگوها"
      onClick={() => sendDoctorDesktopChatsClick(user?.id, 'header')}
      className={classNames(
        'inline-flex h-10 w-10 items-center justify-center rounded-full text-slate-700 transition-colors hover:bg-slate-100',
        active && 'text-primary bg-slate-100',
      )}
    >
      <ChatIcon width={22} height={22} aria-hidden />
    </Link>
  );
};

export default DoctorChatsHeaderLink;
